export function metersToMiles(meters: number) {
	return meters * 0.000621371;
}

export function formatDistance(distance: number, fractionDigits: number = 1, distanceDelimiter: number = 100) {
	if (distance === 0) return '0';
	else if (distance >= distanceDelimiter) return (distance / 1000).toFixed(fractionDigits) + 'k';
	else return distance.toFixed(fractionDigits).toString();
}
